<section>
    @if (isOverflow$$()) {
        <button
            class="tab-group__trigger"
            nw-outline-button
            nw-menu-trigger-button
            size="s"
            [nwMenuTriggerFor]="menu"
        >
            <div class="tab-group__trigger__content">
                @if (tabs$$()[selectedIndex].icon) {
                    <nw-icon
                        [icon]="$any(tabs$$()[selectedIndex].icon)"
                        class="tab-group__tab__content__icon margin-right-m"
                    ></nw-icon>
                }
                <div class="tab-group__tab__content__label">
                    {{ tabs$$()[selectedIndex].label }}
                </div>
            </div>
        </button>
    }
    <div
        #tabGroup
        class="tab-group"
        role="tablist"
        [style.visibility]="isOverflow$$() ? 'hidden' : undefined"
        [style.height.px]="isOverflow$$() ? 0 : undefined"
        [style.opacity]="isOverflow$$() ? 0 : undefined"
    >
        @for (tab of tabs$$(); track tab; let i = $index) {
            <div
                role="tab"
                class="tab-group__tab"
                [attr.tabIndex]="i"
                [attr.aria-posinset]="i + 1"
                [attr.aria-setsize]="tabs$$().length"
                [attr.aria-controls]="'nw-tab-content-' + i"
                [attr.aria-selected]="selectedIndex === i"
                [attr.aria-label]="tab.ariaLabel || null"
                [attr.aria-labelledby]="
                    !tab.ariaLabel && tab.ariaLabelledby ? tab.ariaLabelledby : null
                "
                [attr.disabled]="tab.disabled"
                [attr.data-test]="tab.dataTest || null"
                [class.tab-group__tab--disabled]="tab.disabled"
                [class.tab-group__tab--active]="selectedIndex === i"
                (click)="handleClick(tab, i)"
                (keydown.enter)="handleClick(tab, i)"
            >
                <div
                    class="tab-group__tab__content padding-top-s padding-right-m padding-bottom-s padding-left-m"
                >
                    @if (tab.icon) {
                        <nw-icon
                            [icon]="tab.icon"
                            class="tab-group__tab__content__icon margin-right-m"
                        ></nw-icon>
                    }
                    <div class="tab-group__tab__content__label">{{ tab.label }}</div>
                </div>
            </div>
        }
    </div>

    <div class="tab-content">
        @for (tab of tabs$$(); track tab; let i = $index) {
            @if (selectedIndex === i) {
                <div
                    role="tabpanel"
                    [id]="'nw-tab-content-' + i"
                    [attr.aria-labelledby]="'nw-tab-label-' + i"
                >
                    <ng-template [cdkPortalOutlet]="tab.content"></ng-template>
                </div>
            }
        }
    </div>
</section>

<nw-menu #menu="nwMenu">
    @for (tab of tabs$$(); track tab; let i = $index) {
        <div
            nw-menu-item
            role="listitem"
            [attr.aria-label]="tab.ariaLabel || null"
            (click)="handleClick(tab, i)"
            (keydown.enter)="handleClick(tab, i)"
            [attr.tabIndex]="i"
            [attr.data-test]="tab.dataTest"
            [disabled]="tab.disabled || null"
        >
            @if (tab?.icon) {
                <nw-icon [icon]="$any(tab.icon)"></nw-icon>
            }
            {{ tab.label }}
        </div>
    }
</nw-menu>
